export default __webpack_public_path__ + "static/media/questions_bg.a93b220f.jpg";